import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
// import vuetify from './plugins/vuetify'
import vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'

import VeeValidate from 'vee-validate'

import Plugins from './plugins/pbsplugin'

import VueI18n from 'vue-i18n'
import translations from '@/config/translations'

import { defaultLocale } from '@/config/i18n'
import { defaultFallbackLocale } from '@/config/i18n'

import Errors from '@/components/errors'
import Loader from '@/components/loader'
import Footer from '@/components/footer'

import _ from 'lodash'

// Base URL for all HTTP calls to the database
axios.defaults.baseURL = 'https://matrixappsapi.azurewebsites.net/api'
//axios.defaults.baseURL = 'http://localhost:50680/api'

Vue.use( VeeValidate )
Vue.use( VueI18n )
Vue.use( Plugins)

Vue.component('app-errors', Errors)
Vue.component('app-loader', Loader)
Vue.component('app-footer', Footer)

Vue.config.productionTip = false

let i18n = new VueI18n({
  messages: translations,
  locale: `${defaultLocale}`,
  fallbackLocale: `${defaultFallbackLocale}`,
})

const vuetifyOpts = { lang: { t: (key, ...params) => i18n.t(key, params) } };

Vue.use(vuetify);


new Vue({
  router,
  store,
  vuetify: new vuetify(vuetifyOpts),
  i18n,
  render: h => h(App)
}).$mount('#app')
